module.exports = __webpack_public_path__ + "img/emoji_91.b6fb2d4a.png";